// TheFounders.js
import React from 'react';
import './TheFounders.css';
import siteConfig from '../../configuration/siteConfiguration';
//import { FaLinkedin } from 'react-icons/fa'; // Assuming react-icons is installed

const TheFounders = () => {
  return (
    <section className="the-founders-section">
      <div className="founders-header">
        <div className="wave-bg">
          <img src="/images/wave.svg" alt="" />
        </div>
        <h3>— THE FOUNDERS</h3>
        <h2>People who coined</h2>
      </div>
      <div className="founders-container">
        <div className="founder-column">
          <div className="founder-image-placeholder">
            <img src={`${siteConfig.assetBaseUrl}/founders/DSC_7306.jpg`} height="200px" alt="Divya Singh" />
          </div>
          <div className="founder-details">
            <div className="founder-name-title">
              <h4>Divya Singh</h4>
              <p className="founder-title">Co-Founder & CEO</p>
            </div>
            <a href="#" className="linkedin-link">
              <img src="/images/socialicon.svg" alt="LinkedIn" className="linkedin-icon" />
            </a>
          </div>
          <p className="founder-description">
            A visionary with a techno-commercial mindset and over 25 years of experience across
            Oracle, IBM, Accenture, Genpact, and Salesforce. Divya Singh brings unmatched depth in
            global IT strategy, digital transformation, and GCC leadership. An alumna of both IIM and
            ISB, she seamlessly bridges business and technology to drive scale and innovation.
          </p>
          <p className="founder-description">
            At Cognitva, Divya is the chief architect of the core product strategy for the Cognitva
            CIP™ platform, aligning enterprise needs with AI innovation. She has led the evolution of
            CIP from concept to execution — championing its modular design, compliance-first
            architecture, and cross-industry adaptability. Under her leadership, Cognitva is building an
            entirely new category of scalable intelligence infrastructure for regulated industries.
          </p>
          <p className="founder-description">
            Divya oversees strategic vision, ecosystem partnerships, go-to-market, and investor
            alignment — steering Cognitva from deep tech innovation toward global enterprise
            relevance.
          </p>
        </div>

        <div className="founder-column">
          <div className="founder-image-placeholder">
            <img src={`${siteConfig.assetBaseUrl}/founders/DSC_7105.jpg`} height="200px" alt="Ram B Adhikari" />
          </div>
          <div className="founder-details">
            <div className="founder-name-title">
              <h4>Ram B Adhikari</h4>
              <p className="founder-title">Co-Founder & CTO</p>
            </div>
            <a href="#" className="linkedin-link">
              <img src="/images/socialicon.svg" alt="LinkedIn" className="linkedin-icon" />
            </a>
          </div>
          <p className="founder-description">
            An IIT alumnus and AI/ML innovator, Ram brings technical leadership honed at Microsoft,
            Amazon, Intuit, and Salesforce. He is the chief architect of the Cognitva CIP™ engine,
            designing its patent-pending LLM orchestration, modular agentic blocks, and regulatory
            intelligence framework.
          </p>
          <p className="founder-description">
            Ram leads product engineering, AI research, and platform infrastructure at Cognitva —
            with a focus on explainability, compliance integration, and agentic collaboration. His
            mission is to ensure the platform not only solves problems, but anticipates them —
            turning domain complexity into actionable intelligence at scale.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TheFounders;